import { PrintCardMenu } from './print-card-menu';
import { FONT, FontStyleSheet } from '../font-style-sheets';

export class PennywisePrintCardMenu extends PrintCardMenu {
  whatFontsAreNeededToRenderContent(): FontStyleSheet[] {
    return [FONT.Poppins.SemiBold_600, FONT.Poppins.Bold_700];
  }

  override getAdobeFontFamilyCssUrl(): string | null {
    return 'https://use.typekit.net/qij0imn.css';
  }
}
